const Fieldset: React.FC<FieldsetProps> = ({ children, className, title }) => {
  return (
    <div className={className}>
      {title && <label className="uppercase mb-1 inline-block">{title}</label>}
      <div className="space-y-3">{children}</div>
    </div>
  );
};
export type FieldsetProps = {
  children: React.ReactNode;
  className?: string;
  title?: string;
};

export default Fieldset;
